export default "__VITE_ASSET__jTvDPPfB__"